import Vue from 'vue';

const success = (context, response) => {
  context.captured = true;
  context.payment = response.payment;
  context.paymentItem = response.payment;
  context.isPaymentCreated = true;
  $('.modal-backdrop').remove();
  $('.modal-content').css({ display: 'none' });
  $('.modal-open').attr('style', 'animation-duration: 800ms; opacity: 1;');
  $('.modal-open').removeClass('modal-open');
  $('#payment-modal').hide();
  $('#payment-modal').removeClass('show');
  $('#additional-payment-modal').hide();
  $('#additional-payment-modal').removeClass('show');
  toastr.success(response.msg);
  context.smallLoading = false;
};

const failed = (context, error) => {
  if (error && error.response && error.response.data && error.response.data.msg) {
    const errorMessages = error.response.data.msg;
    if (typeof errorMessages === 'string') {
      toastr.error(errorMessages);
    } else {
      Object.values(errorMessages).forEach((errorMessage) => {
        toastr.error(errorMessage[0]);
      });
    }
  }
  context.isPaymentCreated = false;
  context.smallLoading = false;
};

export default (context, payment) => Vue.$http.post('/payments', payment).then((response) => {
  if (response.status === 200) {
    success(context, response.data);
  } else {
    failed(context, response);
  }
}).catch((error) => {
  failed(context, error);
});



// WEBPACK FOOTER //
// ./src/app/services/payment/save.js